import { createStore, createHook, type Action } from 'react-sweet-state';
import {
	type TimelineMode,
	TimelineModeOptions,
} from '@atlassian/jira-software-deployments-common-table/src/model/timeline';

export type State = {
	timelineMode: TimelineMode;
};

export const initialState: State = {
	timelineMode: TimelineModeOptions.WEEKS,
};

export const actions = {
	setTimelineMode:
		(timelineMode: TimelineMode): Action<State> =>
		({ setState }) =>
			setState({ timelineMode }),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'useTimelineMode',
	initialState,
	actions,
});

export const useTimelineModeStore = createHook(Store);
export const useTimelineMode = createHook(Store, {
	selector: (state) => state.timelineMode,
});
